import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './AttributePicker.module.scss';

const AttributePicker = ({
  valueKey,
  topLabel,
  mediumLabel = undefined,
  mediumElement = undefined,
  bottomLabel = undefined,
  selected = false,
  onSelect,
  isOutOfStock = false,
}) => {
  const clickHandler = () => {
    if (!isOutOfStock) {
      onSelect(valueKey);
    }
  };
  return (
    <div
      data-testid="variant-select"
      className={classnames({
        [styles.container]: !isOutOfStock,
        [styles['container-out-of-stock']]: isOutOfStock,
        [styles.selected]: selected,
      })}
      onClick={clickHandler}
      data-selected={selected}
      role="button"
      tabIndex="0"
      aria-pressed={selected}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          clickHandler();
        }
      }}
    >
      <div className={styles['title-container']}>
        <div className={classnames({ [styles['top-label']]: !isOutOfStock })}>
          {topLabel}
        </div>
      </div>
      {!mediumElement && mediumLabel && (
        <div
          className={classnames({ [styles['medium-label']]: !isOutOfStock })}
        >
          {mediumLabel}
        </div>
      )}
      {mediumElement && <div>{mediumElement}</div>}
      {bottomLabel && (
        <div
          className={classnames({ [styles['bottom-label']]: !isOutOfStock })}
        >
          {bottomLabel}
        </div>
      )}
    </div>
  );
};

AttributePicker.propTypes = {
  topLabel: PropTypes.string.isRequired,
  valueKey: PropTypes.string.isRequired,
  mediumLabel: PropTypes.string,
  mediumElement: PropTypes.node,
  bottomLabel: PropTypes.string,
  selected: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  isOutOfStock: PropTypes.bool,
};

export default AttributePicker;
